import React, { useState, useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import makeAnimated from "react-select/animated";
import { 
  useHistory, 
  useParams, 
} from "react-router-dom";

import { ErrorMessage } from "@hookform/error-message";

import { 
  TextField, 
  FormControl, 
  FormControlLabel,
} from "@material-ui/core";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import InfoIcon from "@material-ui/icons/Info";
import BuildIcon from "@material-ui/icons/Build";
import BlockIcon from "@material-ui/icons/Block";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress"
import Backdrop from "@material-ui/core/Backdrop";

import { apollo_useStyles } from "../../../atom/Apollo_styles";
import {APOLLO_GROUP_OPERATOR, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../../atom/Apollo_Authorization";
import { 
  userlistposeidon_path,
  create_poseidon_userlist_path,
  apollo_user_path,
  update_poseidon_userlist_path,
  delete_poseidon_userlist_path,
  get_poseidon_userlist_path,
  userlisteditposeidon_path,
  upload_poseidon_file_path,
} from "../../../atom/Apollo_links";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { DeleteButton } from "../../../molecule/Apollo_Button";
import { ApolloRightDrawerContext } from "../../../molecule/Apollo_RightDrawer";
import GenericTemplate from "../../../templates/GenericTemplate";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";

import { UsePreference } from "../../SEGMENT/poseidon/SegmentModel";
import {
  CreateUserList,
  ResGetUserList,
  initResGetUserList,
  UpdateUserList,
  DeleteUserList,
} from "./UserListModel";
import { UploadFile } from "../../SEGMENT/poseidon/SegmentModel";

import { InformationDrawer } from "../../../organism/SEGMENT/InformationDrawer";
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";

const animatedComponents = makeAnimated();

// @ts-ignore
const CopyDialog: React.FC<{ userListInfo: string, copyUserList: any }> = ({ userListInfo, copyUserList }) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const title: string = "ユーザーリストコピー";
  const text: string = "このユーザーリストをコピーしますか？ " + userListInfo;

  return (
    <>
      <Button 
        variant="contained"
        onClick={() => {
          handleClickOpen();
        }}
      >
        <FileCopyIcon />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            キャンセル
          </Button>
          <Button
            onClick={() => {
              copyUserList();
            }}
            color="primary"
            autoFocus
          >
            コピー
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

/*
    画面名：ユーザーリスト作成/編集
 */
const UserListEdit: React.FC = () => {
  const classes = apollo_useStyles();
  const history = useHistory();
  const formHooks = useForm<FormData>();
  const { register, handleSubmit, errors, control, formState } = formHooks;
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);
  const processing = useRef(false);

  const {userListId, copyUserListId} = useParams<{
    userListId: string,
    copyUserListId: string
  }>();

  let breadId: number = (userListId === "0") ? 10 : 11;

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: breadId,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // 【useState】
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext); 

  // 編集時ローディング
  const [bdopen, setbdOpen] = React.useState(false);
  
  // userList
  const [userLists, setUserLists] = useState<ResGetUserList>(initResGetUserList);
  const [isEdit, setIsEdit] = useState(false);
  const [checkUsePreference1, setCheckUsePreference1] = useState(true);
  const [checkUsePreference2, setCheckUsePreference2] = useState(false);
  
  const [binary, setBinary] = useState("");
  const [fileName, setFileName] = useState("");
  const [isErrorUpload, setIsErrorUpload] = useState(false);
  const [bucket, setBucket] = useState("");
  const [keyPrefix, setKeyPrefix] = useState("");
  const [region, setRegion] = useState("");

  // 情報
  const [createdBy, setCreatedBy] = useState("");
  const [updatedBy, setUpdatedBy] = useState("");

  useEffect(() => {
    if (userListId !== "0" || copyUserListId !== undefined) {
      let apiUserListId: string = "";
      copyUserListId !== undefined ? apiUserListId = copyUserListId : apiUserListId = userListId;

      bdhandleToggle();

      let url: string = `${get_poseidon_userlist_path}/${apiUserListId}`;
      ApolloAxios.get(url).then(response => {
        let result: any = response.data.result;

        setUserLists(result);

        // 利用設定
        setCheckUsePreference1(false);
        setCheckUsePreference2(false);

        let usePreferences: any = result.usePreference;

        if (result.usePreference !== undefined) {
          if (usePreferences.length > 0) {
            usePreferences.map((usePreference: any) => {
              if (usePreference === UsePreference.Target) {
                setCheckUsePreference1(true);
              }
              if (usePreference === UsePreference.Except) {
                setCheckUsePreference2(true);
              }
            });
          }
        }

        if (copyUserListId === undefined) {
          if (result.fileName === undefined) {
            const warnMsg: string = "ファイルがアップロードされていません。再度ファイルをアップロードしてください。";
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "warning",
                message: warnMsg,
              }
            });
          } else {
            setFileName(result.fileName);
          }
        }

        // 作成者
        url = `${apollo_user_path}${result.createdBy}`;
        ApolloAxios.get(url).then(response => {
          let result1 = response.data.result;

          let createdBy1: string = "undefined (ID："+result.createdBy+")";
          if (result1.familyName !== undefined) {
            createdBy1 = result1.familyName+" "+result1.firstName;
          }

          setCreatedBy(createdBy1)
        }).catch(err => {
          console.log(err)
        });

        // 更新者
        url = `${apollo_user_path}${result.updatedBy}`;
        ApolloAxios.get(url).then(response => {
          let result1 = response.data.result;

          let updatedBy1: string = "undefined (ID："+result.updatedBy+")";
          if (result1.familyName !== undefined) {
            updatedBy1 = result1.familyName+" "+result1.firstName;
          }

          setUpdatedBy(updatedBy1);
        }).catch(err => {
          console.log(err)
        });

        setIsEdit(true);
      }).catch(err => {
        const errMsg: string = "ユーザーリスト情報の取得に失敗しました。";
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          }
        });
        // if (err.redirecturl != "" && err.redirecturl !== undefined) {
        //   const url = err.redirect + history.location.pathname;
        //   history.push( url );
        // }
      }).finally(() => {
        bdhandleClose();
      });
    }
  }, []);

  const onSubmit = handleSubmit(async ( data : any ) => {
    if (formState.isSubmitting) return;
    if (processing.current) return;

    if (data.name === "") {
      const warnMsg: string = "ユーザーリスト名を入力してください。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: warnMsg,
        }
      });

      return;
    }

    let isError: boolean = false;

    if (userListId === "0" && binary === "") {
      isError = true;
    }
    if (userListId !== "0" && fileName === "") {
      isError = true;
    }

    if (isError) {
      const warnMsg: string = "ファイルを選択してください。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: warnMsg,
        }
      });

      return;
    }

    bdhandleToggle();

    let array1: Array<string> = [];

    if (data.usePreference1) {
      array1.push("TARGET")
    }
    if (data.usePreference2) {
      array1.push("EXCEPT")
    }

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    if (userListId === "0") {
      const apiBody: CreateUserList = {
        name: data.name,
        description: data.description,
        usePreference: array1,
        file: binary,
        fileName: fileName,
        accountId: state.current.accountId,
        createdBy: state.userprofile.userId,
      }

      processing.current = true;
      const url: string = create_poseidon_userlist_path;
      ApolloAxios.post(url, apiBody, {timeout: 60000*3}).then(response => {
        if (response.data.result !== null) {
          let result = response.data.result;

          const errMsg: string = "ファイルのアップロードに失敗しました。";
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: errMsg,
            },
          });

          setBinary("");
          setFileName("");

          setIsErrorUpload(true);
          setBucket(result.bucket);
          setKeyPrefix(result.keyPrefix);
          setRegion(result.region);

          return;
        }

        if (response.data.resultCode < 0) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: response.data.message,
            },
          });

          return;
        }

        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: response.data.message,
          },
        });

        history.push(userlistposeidon_path);
      }).catch(err => {
        const errMsg: string = "ユーザーリストの作成に失敗しました。";
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          }
        });
      }).finally(() => {
        processing.current = false;
        bdhandleClose();

        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      });

      return;
    }

    const apiBody: UpdateUserList = {
      id: Number(userListId),
      description: checkDiffUpdateString(userLists.description, data.description),
      usePreference: array1,
      file: binary,
      fileName: fileName,
      updatedBy: state.userprofile.userId,
      expectedVersion: userLists.version,
    };

    processing.current = true;
    const url: string = update_poseidon_userlist_path;
    ApolloAxios.post(url, apiBody, {timeout: 60000*3}).then(response => {
      if (response.data.result !== null) {
        let result = response.data.result;

        const errMsg: string = "ファイルのアップロードに失敗しました。";
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          },
        });

        setBinary("");
        setFileName("");

        setIsErrorUpload(true);
        setBucket(result.bucket);
        setKeyPrefix(result.keyPrefix);
        setRegion(result.region);

        return;
      }

      if (response.data.resultCode < 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
          },
        });

        return;
      }

      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: response.data.message,
        },
      });

      history.push(userlistposeidon_path);
    }).catch(err => {
      const errMsg: string = "ユーザーリストの更新に失敗しました。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      processing.current = false;
      bdhandleClose();

      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
    });
  });

  // 編集時ローディング
  const bdhandleToggle = () => {
    setbdOpen(!bdopen);
  };

  const bdhandleClose = () => {
      setbdOpen(false);
  };

  // 情報(Drawer)
  function openInformation() {
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    });
  };

  function closeInformation() {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  };

  // 戻る
  const handelGoback = () => {
    history.push(userlistposeidon_path);
  };

  // ファイル再アップロード
  const fileReUpload = () => {
    if (binary === "") {
      const warnMsg: string = "ファイルを選択してください。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "warning",
          message: warnMsg,
        }
      });

      return;
    }

    const apiBody: UploadFile = {
      bucket: bucket,
      keyPrefix: keyPrefix,
      region: region,
      file: binary,
      fileName: fileName,
    };

    const url: string = upload_poseidon_file_path;
    ApolloAxios.post(url, apiBody).then(response => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: response.data.message,
        },
      });

      history.push(userlistposeidon_path);
    }).catch(err => {
      const errMsg: string = "ファイルのアップロードに失敗しました。";
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    });
  };

  // 削除
  const handleDelete = () => {
    if (formState.isSubmitting) return;
    if (processing.current) return;

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    const apiBody: DeleteUserList = {
      id: Number(userListId),
      updatedBy: state.userprofile.userId,
      expectedVersion: userLists.version,
    }

    processing.current = true;
    const url: string = delete_poseidon_userlist_path;
    ApolloAxios.post(url, apiBody).then(response => {
      if (response.data.resultCode < 0) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: response.data.message,
          },
        });

        return;
      }

      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: response.data.message,
        },
      });

      history.push(userlistposeidon_path);
    }).catch(err => {
      const errMsg = `ユーザーリストの削除に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {
      processing.current = false;
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
    });
  };

  // ファイル選択 変更時
  const fileChange = (e: any) => {
    if (e.target.files !== null) {
      if (e.target.files.length === 0) {
        return;
      }

      const reader = new FileReader();
      setFileName(e.target.files[0].name);

      reader.onload = () => {
        setBinary(reader.result as string);
      }

      reader.readAsText(e.target.files[0]);
    }

    e.target.value = "";
  }

  // コピーアクション
  function copyUserList() {
    history.push(`${userlisteditposeidon_path}0/${userListId}`);
    window.location.reload();
  };

  // 更新値差分チェック
  function checkDiffUpdateString(valOld: string, valNew: string) {
    if (valOld === valNew) {
      return "";
    }

    return valNew;
  }

  function checkDiffUpdateNumber(valOld: number, valNew: number) {
    if (valOld === valNew) {
      return 0;
    }

    return valNew;
  }

  function checkDiffUpdateArray(valOld: any, valNew: any) {
    valOld.sort();
    valNew.sort();

    let oldVal: string = valOld.join(",");
    let newVal: string = valNew.join(",");

    if (oldVal === newVal) {
      return [];
    }

    return valNew;
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars />
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>

        <Backdrop className={classes.backdrop} open={bdopen} onClick={bdhandleClose}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <form 
          noValidate
          onKeyDown={e => {
            if (e.key === 'Enter') e.preventDefault();
          }}
        >
          {userListId !== "0" ? 
            <Tooltip title="削除" placement="top">
              <Fab color="primary" aria-label="del" className={classes.fab2} disabled={processing.current}>
                <DeleteButton 
                  handleDelete={handleDelete}
                  title="ユーザーリスト削除" 
                  text={`このユーザーリストを削除しますか？ ${userLists.name}(ID:${userListId})`}
                />
              </Fab>
            </Tooltip>
          : ""}

          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                {userListId !== "0" ?
                  <Grid 
                    container 
                    justify="flex-end"
                    direction="row"
                    spacing={1}
                  >
                    <Grid 
                      item xs={3}
                      alignItems="flex-end"
                      style={{paddingLeft: "130px", paddingTop: "25px"}}
                    >
                      <Tooltip title="コピー" placement="top">
                        <span>
                          <CopyDialog
                            userListInfo={`${userLists.name}(ID:${userListId})`}
                            copyUserList={copyUserList}
                          />
                        </span>
                      </Tooltip>
                      <Tooltip 
                        title="情報" 
                        placement="top" 
                        style={{marginLeft: "10px"}}
                      >
                        <Button 
                          variant="contained"
                          onClick={openInformation}
                        >
                          <InfoIcon />
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                : ""}

                {/* 情報表示 (Drawer) */}
                {drawerState.open ? 
                  <InformationDrawer
                    obj={userLists}
                    closeInformation={closeInformation}
                    typeTitle=""
                    createdBy={createdBy}
                    updatedBy={updatedBy}
                  />
                : ""}

                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom component="div">
                    ユーザーリスト名 ※
                  </Typography>
                  <Controller
                    name="name"
                    control={control}
                    components={animatedComponents}
                    key={isEdit ? "Loading" : "Loaded"}
                    defaultValue={copyUserListId !== undefined ? userLists.name+"(コピー)" : userLists.name}
                    as={
                      <TextField
                        placeholder="※ 必須入力項目"
                        id="userListName"
                        fullWidth
                        disabled={userListId !== "0" ? true : false}
                      />
                    }
                  />
                  <p>
                    <ErrorMessage 
                      errors={errors} 
                      name="userListName" 
                      as={<Typography variant="caption" className={classes.errorMessage}/>}
                    />
                  </p>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom component="div">
                    説明
                  </Typography>
                  <Controller
                    name="description"
                    control={control}
                    key={isEdit ? "Loading" : "Loaded"}
                    defaultValue={userLists.description}
                    as={
                      <TextField
                        id="description"
                        fullWidth
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <input
                    id="file1"
                    type="file"
                    accept="text/csv"
                    style={{display: "none"}}
                    onChange={fileChange}
                  />
                  <label htmlFor="file1" style={{marginRight: "10px"}}>
                    <Button 
                      classes={{root: classes.button}} 
                      variant="outlined" 
                      component="span"
                      style={{marginTop: 0}}
                    >
                      ファイルを選択
                    </Button>
                  </label>
                  <label>{fileName}</label>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom component="div">
                    利用設定
                  </Typography>
                  <FormControl>
                    <Grid container spacing={1}>
                      <Grid 
                        container
                        item
                        direction="row"
                        justify="center"
                        alignItems="center"
                      >
                        <BuildIcon 
                          style={{marginRight: "10px"}}
                        />
                        <Controller
                          name="usePreference1"
                          control={control}
                          defaultValue={checkUsePreference1}
                          key={checkUsePreference1 ? "LoadingUsePreference1" : "LoadedUsePreference1"}
                          as={
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={checkUsePreference1}
                                  onChange={e => {
                                    setCheckUsePreference1(e.target.checked);
                                  }}
                                />
                              }
                              label={<span style={{fontSize: "18px"}}>カスタムリストに利用</span>}
                            />
                          }
                        />
                        <BlockIcon 
                          style={{marginRight: "10px"}}
                        />
                        <Controller
                          name="usePreference2"
                          control={control}
                          defaultValue={checkUsePreference2}
                          key={checkUsePreference2 ? "LoadingUsePreference2" : "LoadedUsePreference2"}
                          as={
                            <FormControlLabel
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={checkUsePreference2}
                                  onChange={e => {
                                    setCheckUsePreference2(e.target.checked);
                                  }}
                                />
                              }
                              label={<span style={{fontSize: "18px"}}>除外リストに利用</span>}
                            />
                          }
                        />
                      </Grid>
                    </Grid>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={onSubmit}
                disabled={isErrorUpload || processing.current ? true : false}
                className={classes.button}
              >
                {userListId === "0" ? "作成" : "更新"}
              </Button>
              {isErrorUpload ? 
                <Button
                  variant="contained"
                  color="primary"
                  onClick={fileReUpload}
                  className={classes.button}
                >
                  ファイル再アップロード
                </Button>
              : ""}
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
                disabled={processing.current}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </form>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default UserListEdit;
